export default function ValidationError({ message }) {
	return message ? <span style={{ color: '#e74c3c', display: 'block', fontSize: '.75em', fontWeight: 600, paddingInline: 5}}>{message}</span> : null;
}
